module.exports = {
  GetShipmentsByLocationCode: require("./GetShipmentsByLocationCode"),
  UpdateShipment: require("./UpdateShipment"),
  UploadDocument: require("./UploadDocument"),
  SendMessage: require("./SendMessage"),
};
